import { NewsNoticesTable } from "@/components/news-notices/news-notices-table";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/website/news-notices/")({
  component: NewsNoticesPage,
});

function NewsNoticesPage() {
  return <NewsNoticesTable />;
}
